/**
 * Whether this person allows motion. A test (no `matchMedia`) counts as no,
 * so tests see the final state at once rather than racing an animation.
 */
export function motionAllowed(): boolean {
  return (
    typeof window.matchMedia === "function" &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

/** Waits `ms`, or not at all when motion is off: a beat that is only motion. */
export async function pause(ms: number): Promise<void> {
  if (!motionAllowed() || ms <= 0) return;
  await new Promise<void>((resolve) => {
    window.setTimeout(resolve, ms);
  });
}
